import { NotImplementedError } from "../../../utils/Error";
export var RenderCMDType;
(function (RenderCMDType) {
    RenderCMDType[RenderCMDType["DrawNode"] = 0] = "DrawNode";
    RenderCMDType[RenderCMDType["DrawElement"] = 1] = "DrawElement";
    RenderCMDType[RenderCMDType["Blit"] = 2] = "Blit";
    RenderCMDType[RenderCMDType["ChangeData"] = 3] = "ChangeData";
    RenderCMDType[RenderCMDType["ChangeShaderDefine"] = 4] = "ChangeShaderDefine";
    RenderCMDType[RenderCMDType["ChangeViewPort"] = 5] = "ChangeViewPort";
    RenderCMDType[RenderCMDType["ChangeRenderTarget"] = 6] = "ChangeRenderTarget";
    RenderCMDType[RenderCMDType["ComputeCommandAppatch"] = 7] = "ComputeCommandAppatch";
})(RenderCMDType || (RenderCMDType = {}));
export class SetRenderDataCMD {
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    get dataType() {
        return this._dataType;
    }
    set dataType(value) {
        this._dataType = value;
    }
    get propertyID() {
        return this._propertyID;
    }
    set propertyID(value) {
        this._propertyID = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class SetShaderDefineCMD {
    get define() {
        return this._define;
    }
    set define(value) {
        this._define = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    get add() {
        return this._add;
    }
    set add(value) {
        this._add = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class ComputeCommandAppatchCMD {
    apply(context) {
        throw new NotImplementedError();
    }
}
